/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import { uniqueBy } from '../../utils/array/uniqueBy';
import { botsActions } from './botsSlice';

export const updateRecentBots = (values) => async dispatch => {
  // Clean up the array
  // We only need to keep the bot id, display name and image
  const updatedList = uniqueBy(values.map(bot => {
    const { id, displayName, image } = bot;
    return { id, displayName, image };
  }), 'id').slice(0, 6);

  dispatch(botsActions.recentBotsUpdateComplete(updatedList));
};

